import { render, staticRenderFns } from "./SelectVaccination.vue?vue&type=template&id=7213a524"
import script from "./SelectVaccination.vue?vue&type=script&lang=ts"
export * from "./SelectVaccination.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports